import _Vue from 'vue';

export const $t = ((key: string) => key) as App.TranslateFn;
export const getT = (): App.TranslateFn => _Vue.prototype.$t || $t;
